import CohealerCourseSessions from './CohealerCourseSessions';

export default CohealerCourseSessions;
